let uniqueId = 0;

export const getUniqueId = () => {
  uniqueId++;
  return uniqueId;
};
